/**
 * The tenant-api and core success envelope: `{ success, data }`, with list endpoints adding
 * `pagination` (or page counters) beside `data`. Feature `api.ts` modules pull `data` out so they
 * return plain domain objects. An endpoint that answers in another shape (the auth token
 * endpoints, the gallery) is read field by field where it is called, never through these.
 */
export function unwrap<T>(body: { data: T }): T {
  return body.data;
}

export function unwrapList<T>(body: { data: T[] }): T[] {
  return body.data;
}
